// Niyamavali.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";

import swal from "sweetalert";
const Niyamavali = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("asc");
  const [currentPage, setCurrentPage] = useState(0);
  const sort = 10; // rows per page

  const [searchQueries, setSearchQueries] = useState({
    karm: "",
    status: "",
    content: "",
  });

  const [data, setData] = useState([
    { id: 1, karm: "Karm 1", status: "Active", content: "ही नियमावली 1 आहे" },
    { id: 2, karm: "Karm 2", status: "Inactive", content: "ही नियमावली 2 आहे" },
    { id: 3, karm: "Karm 3", status: "Active", content: "ही नियमावली 3 आहे" },
  ]);

  const totalPages = Math.ceil(data.length / sort);

  const handleSort = (field) => {
    const order = sortField === field && sortOrder === "asc" ? "desc" : "asc";
    setSortField(field);
    setSortOrder(order);
    const sortedData = [...data].sort((a, b) => {
      if (a[field] < b[field]) return order === "asc" ? -1 : 1;
      if (a[field] > b[field]) return order === "asc" ? 1 : -1;
      return 0;
    });
    setData(sortedData);
  };

  const handleSearch = (e, field) => {
    setSearchQueries({ ...searchQueries, [field]: e.target.value });
  };

  const filteredData = data.filter((item) =>
    Object.keys(searchQueries).every((key) =>
      item[key].toString().toLowerCase().includes(searchQueries[key].toLowerCase())
    )
  );

  const handleDelete = (id) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this Niyamavali!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        try {
          setLoading(true);
          // Later: integrate with API here
          // await dispatch(deleteNiyamavaliAction(id));
          // await dispatch(getNiyamavaliListAction());
  
          // For now, just remove from mock data
          setData((prevData) => prevData.filter((item) => item.id !== id));
  
        } catch (error) {
          setError("Failed to delete Niyamavali");
          console.error("Failed to delete Niyamavali:", error);
        } finally {
          setLoading(false);
        }
      }
    });
  };
  
  

  const handleEdit = (niyamavali) => {
    navigate(`/edit-niyamavali/${niyamavali.id}`, {
      state: { niyamavali },
    });
  };
  

  return (
    <>
      <div className="row mb-3">
        <div className="col-xl-12 text-end">
          <Link to="/add-niyamavali" className="btn btn-primary btn-rounded">
            + Add Niyamavali
          </Link>
        </div>
      </div>

      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-body">
              {error && <div className="text-danger mb-2">{error}</div>}

              {loading ? (
                <div className="text-center my-5">Loading...</div>
              ) : (
                <>
                  <div className="table-responsive">
                    <table className="table table-striped mb-4">
                      <thead className="table-light">
                        <tr>
                          <th onClick={() => handleSort("karm")} style={{ cursor: "pointer" }}>
                            Karm{" "}
                            {sortField === "karm" && (sortOrder === "asc" ? "↑" : "↓")}
                            <input
                              className="form-control form-control-sm mt-1"
                              value={searchQueries.karm}
                              onChange={(e) => handleSearch(e, "karm")}
                              placeholder="Search Karm"
                              onClick={(e) => e.stopPropagation()}
                            />
                          </th>
                          <th onClick={() => handleSort("status")} style={{ cursor: "pointer" }}>
                            Status{" "}
                            {sortField === "status" && (sortOrder === "asc" ? "↑" : "↓")}
                            <input
                              className="form-control form-control-sm mt-1"
                              value={searchQueries.status}
                              onChange={(e) => handleSearch(e, "status")}
                              placeholder="Search Status"
                              onClick={(e) => e.stopPropagation()}
                            />
                          </th>
                          <th onClick={() => handleSort("content")} style={{ cursor: "pointer" }}>
                            Niyamavali{" "}
                            {sortField === "content" && (sortOrder === "asc" ? "↑" : "↓")}
                            <input
                              className="form-control form-control-sm mt-1"
                              value={searchQueries.content}
                              onChange={(e) => handleSearch(e, "content")}
                              placeholder="Search Content"
                              onClick={(e) => e.stopPropagation()}
                            />
                          </th>
                          <th className="text-center">Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {filteredData.length > 0 ? (
                          filteredData
                            .slice(currentPage * sort, (currentPage + 1) * sort)
                            .map((item) => (
                              <tr key={item.id}>
                                <td>{item.karm}</td>
                                <td>
                                  <span
                                    className={`badge px-3 py-1 rounded-pill text-white ${
                                      item.status.toLowerCase() === "active"
                                        ? "bg-success"
                                        : "bg-danger"
                                    }`}
                                  >
                                    {item.status}
                                  </span>
                                </td>
                                <td>{item.content}</td>
                                <td className="text-center align-middle">
                                  <div className="d-inline-flex gap-3">
                                    <button
                                      className="btn btn-link p-0"
                                      onClick={() => handleEdit(item)}
                                      aria-label="Edit"
                                      title="Edit Niyamavali"
                                    >
                                      <i className="fa fa-pencil-alt fs-5 text-success"></i>
                                    </button>
                                    <button
                                      className="btn btn-link p-0"
                                      onClick={() => handleDelete(item.id)}
                                      aria-label="Delete"
                                      title="Delete Niyamavali"
                                    >
                                      <i className="fa fa-trash fs-5 text-danger"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan="4" className="text-center py-4">
                              No Niyamavali found
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>

                  {/* Pagination */}
                  <div
                    className="pagination-wrapper"
                    style={{
                      display: "flex",
                      gap: "6px",
                      alignItems: "center",
                      justifyContent: "center",
                      marginTop: "20px",
                      flexWrap: "wrap",
                      flexDirection: "column",
                    }}
                  >
                    <div>
                      Showing {filteredData.length === 0 ? 0 : currentPage * sort + 1} to{" "}
                      {Math.min((currentPage + 1) * sort, filteredData.length)} of {filteredData.length} entries
                    </div>
                    <div style={{ display: "flex", gap: "6px", flexWrap: "wrap", justifyContent: "center" }}>
                      <button
                        onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 0))}
                        disabled={currentPage === 0}
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          color: "#000",
                          cursor: currentPage === 0 ? "not-allowed" : "pointer",
                          opacity: currentPage === 0 ? 0.5 : 1,
                        }}
                      >
                        &lt;
                      </button>
                      
                      {(() => {
                        const pages = [];
                        const maxPagesToShow = 5;
                        const startPage = Math.max(0, Math.min(currentPage - 2, totalPages - maxPagesToShow));
                        const endPage = Math.min(startPage + maxPagesToShow, totalPages);
                        
                        if (startPage > 0) {
                          pages.push(
                            <button
                              key={0}
                              onClick={() => setCurrentPage(0)}
                              style={{
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                color: "#000",
                                cursor: "pointer",
                              }}
                            >
                              1
                            </button>
                          );
                          if (startPage > 1) {
                            pages.push(
                              <span key="dots1" style={{ padding: "6px 12px", userSelect: "none" }}>
                                ...
                              </span>
                            );
                          }
                        }
                        
                        for (let i = startPage; i < endPage; i++) {
                          const isActive = currentPage === i;
                          pages.push(
                            <button
                              key={i}
                              onClick={() => setCurrentPage(i)}
                              style={{
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: isActive ? "#007bff" : "#fff",
                                color: isActive ? "#fff" : "#000",
                                cursor: "pointer",
                              }}
                            >
                              {i + 1}
                            </button>
                          );
                        }
                        
                        if (endPage < totalPages) {
                          if (endPage < totalPages - 1) {
                            pages.push(
                              <span key="dots2" style={{ padding: "6px 12px", userSelect: "none" }}>
                                ...
                              </span>
                            );
                          }
                          pages.push(
                            <button
                              key={totalPages - 1}
                              onClick={() => setCurrentPage(totalPages - 1)}
                              style={{
                                padding: "6px 12px",
                                border: "1px solid #ddd",
                                borderRadius: "4px",
                                backgroundColor: "#fff",
                                color: "#000",
                                cursor: "pointer",
                              }}
                            >
                              {totalPages}
                            </button>
                          );
                        }
                        return pages;
                      })()}
                      
                      <button
                        onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages - 1))}
                        disabled={currentPage === totalPages - 1}
                        style={{
                          padding: "6px 12px",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          backgroundColor: "#fff",
                          color: "#000",
                          cursor: currentPage === totalPages - 1 ? "not-allowed" : "pointer",
                          opacity: currentPage === totalPages - 1 ? 0.5 : 1,
                        }}
                      >
                        &gt;
                      </button>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Niyamavali;
